import React, {Fragment} from "react";
import {Route, Routes} from "react-router-dom";
import TransactionLayout from "./pages/layouts/TransactionLayout";
import NotFoundPage from "./pages/NotFoundPage";
import BaseLayout from "./pages/layouts/BaseLayout";
import SignInPage from "./pages/SignInPage";
import ProfilePage from "./pages/ProfilePage";
import {useAppSelector} from "./hooks/redux";
import BulkUploadPage from "./pages/BulkUploadPage";
import AccountsPage from "./pages/AccountsPage";
import BulkUploadSessionPage from "./pages/BulkUploadSessionPage";
import StatsLayout, {StatsIndexRedirect} from "./pages/layouts/StatsLayout";
import FreestyleStatsPage from "./pages/stats/FreestyleStatsPage";
import StatsModelsPage from "./pages/stats/StatsModelsPage";
import StatsModelFormPage from "./pages/stats/StatsModelFormPage";
import StatsModelRunPage from "./pages/stats/StatsModelRunPage";
import ModelLayout, {ModelIndexRedirect} from "./pages/layouts/ModelLayout";
import ExpenseCategoriesPage from "./pages/model/ExpenseCategoriesPage";
import IncomeCategoriesPage from "./pages/model/IncomeCategoriesPage";

function App() {
    const user = useAppSelector(state => state.auth.user);

    return (
        <>
            <Routes>
                <Route path="/" element={<BaseLayout/>}>
                    {user
                        ? <Fragment>
                            <Route path="*" element={<NotFoundPage/>}/>
                            <Route path="transactions/*" element={<TransactionLayout/>}/>
                            <Route path="accounts" element={<AccountsPage/>}/>
                            <Route path="model" element={<ModelLayout/>}>
                                <Route index element={<ModelIndexRedirect/>}/>
                                <Route path="expense" element={<ExpenseCategoriesPage/>}/>
                                <Route path="income" element={<IncomeCategoriesPage/>}/>
                            </Route>
                            <Route path="profile" element={<ProfilePage/>}/>
                            <Route path="stats" element={<StatsLayout/>}>
                                <Route index element={<StatsIndexRedirect/>}/>
                                <Route path="models" element={<StatsModelsPage/>}/>
                                <Route path="models/new" element={<StatsModelFormPage/>}/>
                                <Route path="models/:id/edit" element={<StatsModelFormPage/>}/>
                                <Route path="models/:id" element={<StatsModelRunPage/>}/>
                                <Route path="freestyle" element={<FreestyleStatsPage/>}/>
                            </Route>
                            <Route path="bulk_upload/sessions" element={<BulkUploadPage/>}/>
                            <Route path="bulk_upload/sessions/:id" element={<BulkUploadSessionPage/>}/>
                        </Fragment>
                        : <Route path="*" element={<SignInPage/>}/>}
                </Route>
            </Routes>
        </>
    );
}

export default App;
